import { render } from "./TrainingCertificateInformation.vue?vue&type=template&id=06091aa7&ts=true"
import script from "./TrainingCertificateInformation.vue?vue&type=script&lang=ts"
export * from "./TrainingCertificateInformation.vue?vue&type=script&lang=ts"

import "./TrainingCertificateInformation.vue?vue&type=style&index=0&id=06091aa7&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__